//export const Url="https://mirx.com.ar/pv/";
export const Url = "https://mirx.com.ar/izzy/";

